import styled from 'styled-components';
import { Box } from 'grommet';

export const ClientsStyled = styled(Box)`

`;